<template>
	<div class="share-group">
		<a :href="facebookShareURL" class="share-link" target="_blank" @click="trackShare('Facebook')">
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.69 30.69" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g data-name="Layer 2"><g data-name="Layer 1"><path d="M15.35 0a15.35 15.35 0 1015.34 15.34A15.34 15.34 0 0015.35 0zm5.82 8.64h-2.22c-1.72 0-1.7 1.28-1.7 1.34v3.19l3.94.08-.58 4.07h-3.36l-.1 8.61h-4L13 17.34H9.45l.09-4.15H13v-3c0-.32 0-.64.08-1a6 6 0 01.61-2 4.27 4.27 0 011.18-1.39 4.83 4.83 0 011.7-.8 5.35 5.35 0 011.31-.21c.57 0 2.81 0 3.37.06z" data-name="Icons" fill="#bf8043"/></g></g></svg>
		</a>
		<a :href="twitterShareURL" class="share-link" target="_blank" @click="trackShare('Twitter')">
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 112.2 112.2" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g data-name="Layer 2"><path d="M56.1 0a56.1 56.1 0 1056.1 56.1A56.1 56.1 0 0056.1 0zm27.67 47.26v1.73c0 17.72-13.49 38.15-38.15 38.15a38 38 0 01-20.56-6 28.2 28.2 0 003.2.19A26.94 26.94 0 0045 75.57a13.42 13.42 0 01-12.52-9.32 13.43 13.43 0 006-.23 13.41 13.41 0 01-10.75-13.14v-.17a13.24 13.24 0 006.07 1.67 13.44 13.44 0 01-4.15-17.9 38.07 38.07 0 0027.64 14 13.42 13.42 0 0122.85-12.22A26.88 26.88 0 0088.66 35a13.5 13.5 0 01-5.9 7.42 27.18 27.18 0 007.7-2.11 27.25 27.25 0 01-6.69 6.95z" data-name="Capa 1" fill="#418f84"/></g></svg>
		</a>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
	computed: {
		...mapState({
			social: (state) => state.global.api.data.social,
		}),
		encodedUrl() {
			return encodeURIComponent(window.location.origin);
		},
		facebookShareURL() {
			return `https://www.facebook.com/sharer/sharer.php?u=${this.encodedUrl}&quote=${encodeURIComponent(this.social.facebook.share_text)}`;
		},
		twitterShareURL() {
			return `https://twitter.com/share?url=${this.encodedUrl}&text=${encodeURIComponent(this.social.twitter.share_text)}`;
		},
	},
	methods: {
		...mapActions("analytics", { trackEvent: "trackEvent" }),
		trackShare(site) {
			this.trackEvent({
				eventCategory: "Social",
				eventAction: site,
				eventLabel: "Share",
			});
		},
	},
};
</script>

<style lang="scss" scoped>
	.share-group {
		display: flex;
	}

	.share-link {
		display: inline-block;
		width: 50px;
		height: 50px;

		@include mobile {
			width: 40px;
			height: 40px;
		}

		& + & {
			margin-left: 1rem;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/base/SocialShare.vue